/* unplugin-vue-components disabled */import script from "./TravelOrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelOrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./TravelOrderDetails.vue?vue&type=style&index=0&id=08fd734d&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fd734d"]])

export default __exports__